module.exports = __webpack_public_path__ + "img/stickers_0014_cloud.c12eb230.png";